import React, {useMemo} from "react";
import {FaCheck} from "react-icons/fa";
import {FaTriangleExclamation} from "react-icons/fa6";
import ReferenceImportModal from "../../../../../components/reference-import-modal/reference-import-modal.jsx";
import streetService from "../../../../../services/web/street-service.js";

const StreetImport = ({open, setOpen, refetch, setIsLoading}) => {
    const columnDefs = useMemo(() => {
        const reasonLabels = {
            "street.import.name.empty": "Nome vazio.",
            "street.import.name.duplicated": "Nome repetido na planilha.",
            "street.import.name.already.used": "Logradouro já cadastrado."
        };

        return [
            {headerName: "", field: "status", width: 56, sortable: false, cellRenderer: ({value}) => <div className="flex h-full items-center justify-center">{value === "NEW" ? <FaCheck color="#219453"/> : <FaTriangleExclamation color="#ed5565"/>}</div>},
            {headerName: "Linha", field: "row", width: 90},
            {headerName: "Nome", field: "name", flex: 1, minWidth: 220},
            {headerName: "Status", field: "status", width: 120, valueFormatter: ({value}) => value === "NEW" ? "Novo" : "Ignorado"},
            {headerName: "Motivo", field: "reason", flex: 1, minWidth: 240, valueFormatter: ({value}) => reasonLabels[value] ?? value}
        ];
    }, []);

    const getPreviewErrorMessage = (error) => {
        const messages = {
            "street.import.file.structure.invalid": "A planilha de importação não corresponde ao formato exigido. Utilize o modelo disponibilizado.",
            "street.import.file.type.invalid": "Selecione um arquivo Excel válido.",
            "street.import.file.invalid": "O arquivo Excel é inválido ou não pode ser lido.",
            "street.import.file.size.invalid": "O arquivo excede o limite de 5 MB.",
            "street.import.rows.limit.exceeded": "A planilha excede o limite de 5.000 linhas."
        };

        return messages[error.response?.data?.message] ?? "Não foi possível gerar a prévia da importação.";
    };

    const downloadTemplate = () => {
        window.location.href = streetService.importTemplateUrl();
        return Promise.resolve();
    };

    const buildPayload = (rows) => ({streets: rows.filter(({status}) => status === "NEW").map(({name}) => name)});

    return <ReferenceImportModal
        open={open}
        setOpen={setOpen}
        refetch={refetch}
        setIsLoading={setIsLoading}
        title="Importação de logradouros"
        columnDefs={columnDefs}
        previewImport={streetService.importPreview}
        createImport={streetService.createImport}
        buildPayload={buildPayload}
        downloadTemplate={downloadTemplate}
        getPreviewErrorMessage={getPreviewErrorMessage}
        successMessage={(created, ignored) => `Importados: ${created}<br>Não importados: ${ignored}`}
        successTitle="Logradouro"
        importErrorMessage="Não foi possível importar os logradouros."
        templateErrorMessage="Não foi possível baixar o modelo de importação."
    />;
};

export default StreetImport;
